export const MIN_BULLETS_COUNT = 3;
export const MAX_VISIBLE_BULLETS_COUNT = 5;

export const carouselEffectsSettings = {
  cube: {
    cubeEffect: {
      shadow: true,
      slideShadows: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  },
  coverflow: {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 0.3,
      slideShadows: false
    }
  },
  cards: {
    cardsEffect: {
      slideShadows: false
    }
  },
  slide: {},
  flip: {},
  creative: {},
  fade: {}
};
